import React, { Component } from 'react';

import './style.sass';
import CommonTitle from '../../../common-components/common-title';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';
import CommonSmallText from '../../../common-components/common-small-text';

class Complexity extends Component {
    render() {
        return (
            <ScrollAnimation animateIn="fadeInUp" offset={100} animateOnce={true} duration={1}>
                <div className="complexity">
                    <div className="complexity__inner">
                        <CommonTitle className="complexity__title">Сложности</CommonTitle>

                        <CommonSmallText className="complexity__text">
                            Высокая конкуренция в&nbsp;нише, премиальность бренда, широкий товарный
                            ряд, разрозненная целевая аудитория по&nbsp;интересам и&nbsp;геолокации.
                        </CommonSmallText>
                    </div>
                </div>
            </ScrollAnimation>
        );
    }
}

export default Complexity;
